import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <FeaturesSection />
        <CardsSection />
        <MediaSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
        <TopicsSection />
        <RankingSection />
        <IndexSection />
        <CarouselSection />
        <CommentsSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}